<!-- Button -->
<button
    mat-icon-button
    [attr.aria-label]="tooltip || 'Toggle Fullscreen'"
    [matTooltip]="tooltip || 'Toggle Fullscreen'"
    (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
</ng-template>
